import type { TCreateTripTaskReq } from 'api/swagger';
import type { ETripTaskType } from 'types/trips';

export { type TAddressFields, type TCoordinatesFields, type TLocationFields, ELocationMode } from 'types/location';

export type TCreationMode = 'separate_tasks' | 'one_task';

export type TWarehouseFields = {
  warehouseId?: number;
};

export type TTaskTypeWithLocation =
  | ETripTaskType.loading
  | ETripTaskType.unloading
  | ETripTaskType.customs
  | ETripTaskType.reloading_to
  | ETripTaskType.reloading_from;

export type TTaskTypeWithWarehouse =
  | ETripTaskType.loading_wh
  | ETripTaskType.unloading_wh
  | ETripTaskType.reloading_from;

export enum EStepKey {
  taskType = 'taskType',
  creationMode = 'creationMode',
  details = 'details',
}

export interface ITripCreateTaskModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (state: TCreateTripTaskReq) => void;
  isPending: boolean;
}

export type TFieldInputValue = string | number | undefined;
